function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useFormContext } from 'components/Form/FormContext';
import { RadioButton } from '../RadioButton/RadioButton';
import * as S from './RadioGroup.styles';
const RadioGroup = /*#__PURE__*/React.forwardRef(({
  ariaLabel,
  defaultValue = '',
  disabled,
  onValueChange,
  options,
  orientation,
  size
}, ref) => {
  const context = useFormContext();
  const renderOptions = () => {
    return options.map(option => /*#__PURE__*/React.createElement(RadioButton, _extends({
      key: option.id
    }, option, {
      disabled: disabled || option.disabled,
      size: size
    })));
  };
  const getSize = () => {
    if (size) {
      return size;
    }
    if (context?.inputSize === 'large') {
      return 'large';
    }
    return 'small';
  };
  const getIsHorizontal = () => {
    if (orientation === 'vertical') {
      return false;
    }
    return orientation === 'horizontal' || context?.orientation === 'horizontal';
  };
  return /*#__PURE__*/React.createElement(S.RadioGroupContainer, {
    "aria-label": ariaLabel,
    onValueChange: onValueChange,
    defaultValue: defaultValue,
    disabled: disabled,
    ref: ref,
    $size: getSize(),
    $isHorizontal: getIsHorizontal()
  }, renderOptions());
});
export { RadioGroup };